module.exports = __webpack_public_path__ + "static/media/automation.e1d31b35.png";